/** @jsx jsx */
import { jsx } from '@emotion/core';

import colors from '../../css/colors';

const tooTipWrap = {
  display: 'inline-flex',
  position: 'relative',
  justifyContent: 'center',
  verticalAlign: 'top',
  '&:hover': {
    ' > span': {
      opacity: 1,
      transition: 'all 0s ease 1s',
    },
  },
};

const toolTip = {
  alignItems: 'center',
  backgroundColor: colors.black,
  borderRadius: '5px',
  color: colors.white,
  display: 'flex',
  height: 40,
  justifyContent: 'center',
  position: 'absolute',
  top: -56,
  opacity: 0,
  width: 'auto',
  whiteSpace: 'nowrap',
  padding: 16,
  ' span': {
    borderColor: '#333 transparent transparent transparent',
    borderStyle: 'solid',
    borderWidth: '6px 6px 0 6px',
    height: 0,
    position: 'absolute',
    bottom: -6,
    width: 0,
  },
};

const ToolTip = ({ children, toolTipText, wrapOverrides, toolTipOverrides, displayContents = false }) => {
  tooTipWrap.display = displayContents ? 'contents' : 'inline-flex';
  return (
    <div css={[tooTipWrap, wrapOverrides]}>
      {children}
      <span css={[toolTip, toolTipOverrides]}>
        {toolTipText}
        <span />
      </span>
    </div>
  );
};

export default ToolTip;
